export default function (instance) {
  return {
    createOrder (bundle) {
      return instance
        .post('/api/checkout/create', {
          bundleName: bundle
        })
        .then(response => response.data)
    },

    featchOrderDetail (orderNumber) {
      return instance
        .get('/api/checkout/details', {
          params: {
            orderNumber
          }
        })
        .then(response => response.data)
    },

    submitOrder (orderNumber, paymentMethodCode, promotionCode, replenishmentQuantity, trackCookie, cancelPaymentUrl) {
      return instance
        .post('/api/checkout/submit', {
          orderNumber,
          paymentMethodCode,
          promotionCode,
          replenishmentQuantity,
          trackCookie,
          cancelPaymentUrl
        })
        .then(response => response.data)
    }
  }
}
